import Vue from 'vue';

import { RoleNameEnum } from '@/bundles/Roles/types';

export default Vue.extend({
  computed: {
    isAdmin (): boolean {
      return (this.$store as any).state.userRoles.includes(RoleNameEnum.ADMIN) || this.isSuperAdmin;
    },
    isSuperAdmin (): boolean {
      return (this.$store as any).state.userRoles.includes(RoleNameEnum.SUPER_ADMIN);
    },
    isMarketingAdmin (): boolean {
      return (this.$store as any).state.userRoles.includes(RoleNameEnum.MARKETING_ADMIN) || this.isSuperAdmin;
    },
    isFinancialAdmin (): boolean {
      return (this.$store as any).state.userRoles.includes(RoleNameEnum.FINANCIAL_ADMIN) || this.isSuperAdmin;
    },
    isFinancialOrMarketingAdmin (): boolean {
      return this.isFinancialAdmin || this.isMarketingAdmin;
    },
    isClient (): boolean {
      return (this.$store as any).state.userRoles.includes('client');
    }
  },
});
